<template>
  <RouterLink :to="link" class="search-item">
    <div class="search-item__content" v-html="text" />
  </RouterLink>
</template>

<script>
/**
 * @vue-prop {Object} value - Contains information about the search result item
 * @vue-prop {String} type - Type of result item ('problem', 'action' or 'gembaWalk')
 */


export default {

  name: 'SearchItem',

  props: {
    value: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['problem', 'action', 'gembaWalk'].indexOf(value) !== -1;
      },
    },
  },

  computed: {
    link() {
      switch (this.type) {
        case 'problem':
          return this.getPbSheetLink(this.value.id);
        case 'action':
          return this.getActionCreationLink(this.value.id);
        case 'gembaWalk':
          return `/gw-completed/${this.value.id}`;
        default:
          return '/dashboard';
      }
    },
    text() {
      const idDots = `${this.$t('message.ID')}${this.$t('message.TWO_DOTS')}`;
      switch (this.type) {
        case 'problem':
          return `<em>${idDots}${this.value.id}</em> - ${this.value.lWhat}`;
        case 'action':
          return `<em>${idDots}${this.value.id}</em> - ${this.value.name}`;
        case 'gembaWalk':
          return `${this.value.name} - ${this.$moment(this.value.date).format(this.$t('dateFormat'))}`;
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss">

.search-item {
  display: block;
  height: 2rem;
  padding-bottom: .2rem;
  box-sizing: border-box;

  &__content {
    background: #efefef;
    padding: 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
